import ajax from "../utils/request.js";
var http = 'http://192.168.0.76:8081'
//登录 POST /api/login
const Signlogins = (data) => {
  return ajax.post("/api/login", data);
};
//用户列表 get /api/user/lists
const userlists = (data) => {
  return ajax.get("/api/user/lists", data);
};
//删除用户 POST /api/user/delete
const userdelete = (data) => {
  return ajax.post("/api/user/delete", data);
};
//反馈消息  GET  /api/msg/lists
const msglists = (data) => {
  return ajax.get("/api/msg/lists", data);
};
//反馈消息详情   POST /api/msg/detail
const msgdetail = (data) => {
  return ajax.post("/api/msg/detail", data);
};
//回复留言   POST /api/msg/reply
const msgreply = (data) => {
  return ajax.post("/api/msg/reply", data);
};

//图片上传   POST /api/upload
const uploadimg = (data) => {
  return ajax.post("/api/upload", data);
};
//返回域名  GET /api/host
const hostimg = (data) => {
  return ajax.get("/api/host", data);
};
//获取菜单  GET /api/menus
const apimenus = (data) => {
  return ajax.get("/api/menus", data);
};

//导入   POST /api/excel/import  
// type  类型 category_gift （礼品分类），category_products（产品线），integral（积分）， gift （礼品），
const excelimport = (data) => {
  return ajax.post("/api/excel/import", data);
};
//导出   POST /api/excel/export
// type  类型  audit_integral （审核积分），gift（礼品），integral（积分），issue（发送秘钥），user（用户）
const excelexport = (data) => {
  return ajax.posttwo("/api/excel/export", data);
};

//礼品分类模板    GET /api/gift/template
const categoryGifttemplate = (data) => {
  return ajax.gets("/api/categoryGift/template", data);
};
//礼品模板    GET /api/gift/template
const gifttemplate = (data) => {
  return ajax.gets("/api/gift/template", data);
};

//产品线模板    GET /api/products/template
const productstemplate = (data) => {
  return ajax.gets("/api/products/template", data);
};
//产品线----积分模板    GET /api/integral/template
const integraltemplate = (data) => {
  return ajax.gets("/api/integral/template", data);
};

//用户相关记录   1=积分 2=兑换    GET /api/detailIntegral/lists
const detailIntegral = (data) => {
  return ajax.get("/api/detailIntegral/lists", data);
};
//获取国家    GET /api/getCountry
const getCountry = (data) => {
  return ajax.get("/api/getCountry", data);
};
//获取国家    GET /api/detailIntegral/add
const detailIntegraladd = (data) => {
  return ajax.post("/api/detailIntegral/add", data);
};
//币种选择    GET /api/getCurrencys
const getCurrencys = (data) => {
  return ajax.get("/api/getCurrencys",data)
}

//修改币种
const currencyEdit = (data) => {
  return ajax.post("/api/currency/edit",data)
}
export {
  Signlogins,
  userlists,
  userdelete,
  msglists,
  msgreply,
  msgdetail,
  uploadimg,
  hostimg,
  apimenus,
  excelimport,
  excelexport,
  gifttemplate,
  categoryGifttemplate,
  productstemplate,
  integraltemplate,
  detailIntegral,
  getCountry,
  detailIntegraladd,
  getCurrencys,
  currencyEdit
}